window.setSwatches = async (handle) => {

  const swatches = await getSwatches(handle)

  let swatches_json = JSON.parse(swatches)
  let swatches_obj = swatches_json.swatches

  for (idx in swatches_obj) {

    let swatch_el = document.querySelector(`[data-option-name="${ swatches_obj[idx].variant_name }"]`)

    if (swatch_el && swatches_obj[idx].variant_color) {
      swatch_el.style.backgroundColor = swatches_obj[idx].variant_color
    }

    if (swatch_el && swatches_obj[idx].variant_swatch) {
      swatch_el.style.backgroundImage = `url(${ swatches_obj[idx].variant_swatch })`
    }
  }

}

async function getSwatches (handle) {
  try {
    const response = await fetch(`/products/${ handle }?view=swatches`)
    let json = await response.json()
    return json
  } catch (error) {
    console.warn(error)
  }
}
